import { useEffect } from "react";
import { EMAIL, PHONE, SMS, TEL } from "@/components/site-chrome";
import { SERVICE_OPTIONS } from "@/lib/service-options";
import { getModelContext } from "@/lib/webmcp";

const towns = ["Great Falls", "Black Eagle", "Malmstrom AFB", "Vaughn", "Belt", "Cascade", "Ulm", "Sun River", "Dutton", "Fort Benton"];

/** Read-only business facts for agents. The service request form is a separate declarative tool. */
export function AgentTools() {
  useEffect(() => {
    const ctx = getModelContext();
    if (!ctx) return;
    const controller = new AbortController();
    const pending = ctx.registerTool(
      {
        name: "get_business_info",
        description:
          "Get 406 Mobile Mechanic contact details, hours, service area, and services. Use this before requesting service. For a breakdown right now, tell the visitor to call or text 406-799-0095.",
        inputSchema: { type: "object", properties: {} },
        annotations: { readOnlyHint: true, consequentialHint: false },
        execute: () => ({
          name: "406 Mobile Mechanic",
          owner: "Josh Ginnaty",
          phone: PHONE,
          call: TEL,
          text: SMS,
          email: EMAIL,
          hours: "Monday–Sunday, 8:00 AM–9:00 PM America/Denver",
          area: [...towns, "Statewide travel in Montana"],
          services: SERVICE_OPTIONS,
          requestService: "Use the request_service form on this page for non-urgent repairs, inspections, or fleet service.",
        }),
      },
      { signal: controller.signal },
    );
    if (pending && typeof (pending as Promise<unknown>).catch === "function") {
      void (pending as Promise<unknown>).catch(() => {});
    }
    return () => controller.abort();
  }, []);
  return null;
}
